<mat-form-field class="year-picker">
    <mat-label></mat-label>
    <mat-select panelClass="year-picker-select" matNativeControl (selectionChange)="select($event)" [(ngModel)]="selectedYear">
        <mat-option *ngFor="let option of options" [value]="option">
            {{option}}
        </mat-option>
    </mat-select>
</mat-form-field>
